import axios, { AxiosInstance } from "axios";
import {
  acquireToken,
  apiScope,
  authEnabled,
  orchestratorApiScope,
} from "../auth/authConfig";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}api/`,
});

// Root API client without the trailing 'api/' segment for endpoints like 'putwalls'
const RootAPI = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

// Orchestrator API
const OrchestratorAPI = axios.create({
  baseURL: `${process.env.REACT_APP_ORCHESTRATOR_API_URL}`,
});

// Attach an Entra ID bearer token to every request when auth is enabled.
// No-op when REACT_APP_CLIENT_ID is empty/undefined (local dev, unconfigured envs).
const addAuthInterceptor = (instance: AxiosInstance, scope: string) => {
  if (!authEnabled) {
    return;
  }
  instance.interceptors.request.use(async (config) => {
    const token = await acquireToken(scope);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
};

addAuthInterceptor(API, apiScope);
addAuthInterceptor(RootAPI, apiScope);
addAuthInterceptor(OrchestratorAPI, orchestratorApiScope);

export default API;
export { RootAPI, OrchestratorAPI };
